/**
 * Antwort-Vorlagen (nach Kundenrückmeldung) — Spiegel zu server/replyTemplates.js
 */

export const REPLY_TEMPLATE_TYPES = new Set([
  'reply_meeting',
  'reply_questions',
  'reply_info',
  'reply_later',
  'reply_wrong_person',
  'reply_no_interest',
  'reply_other_solution',
]);

export const LEGACY_FIRST_REPLY_TYPE = 'first_reply';

export function isReplyTemplateType(type) {
  const t = String(type || '').trim();
  return REPLY_TEMPLATE_TYPES.has(t) || t === LEGACY_FIRST_REPLY_TYPE;
}

export const REPLY_TEMPLATE_TYPE_OPTIONS = [
  { value: 'reply_meeting', label: 'Termin vereinbaren' },
  { value: 'reply_questions', label: 'Auf Fragen eingehen' },
  { value: 'reply_info', label: 'Infos & Testzugang' },
  { value: 'reply_later', label: 'Später wieder melden' },
  { value: 'reply_wrong_person', label: 'Anderen Ansprechpartner' },
  { value: 'reply_no_interest', label: 'Höfliche Absage / Kein Interesse' },
  { value: 'reply_other_solution', label: 'Bereits eine andere Lösung im Einsatz' },
];

/** Feste Reihenfolge in der Antworten-Liste (wie Follow-ups) */
export const REPLY_TEMPLATE_ORDER = [
  'reply_meeting',
  'reply_questions',
  'reply_info',
  'reply_later',
  'reply_wrong_person',
  'reply_no_interest',
  'reply_other_solution',
];

export function sortReplyTemplates(list = []) {
  return [...list].sort((a, b) => {
    const ia = REPLY_TEMPLATE_ORDER.indexOf(String(a?.type || ''));
    const ib = REPLY_TEMPLATE_ORDER.indexOf(String(b?.type || ''));
    const oa = ia === -1 ? 99 : ia;
    const ob = ib === -1 ? 99 : ib;
    if (oa !== ob) return oa - ob;
    return String(a?.name || '').localeCompare(String(b?.name || ''), 'de', { sensitivity: 'base' });
  });
}
